import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
import Qs from 'qs'

const getTransactions = (organizationId, filters) =>
  axiosInstance.get(`${SERVICES.BALANCE_TRANSACTIONS}/${organizationId}`, {
    params: filters,
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
  })
const getTransactionExport = (organizationId, filters) =>
  axiosInstance.get(`${SERVICES.BALANCE_TRANSACTIONS}/${organizationId}/export`, {
    params: filters,
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
    responseType: 'blob',
  })

const getSMSTransactionsExport = (organizationId, filters) =>
    axiosInstance.get(`${SERVICES.CAMPAIGN_TRANSACTIONS}/${organizationId}/sms/download`, {
      params: filters,
      paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
      responseType: 'blob'
    })

const getEmailTransactionsExport = (organizationId, filters) =>
    axiosInstance.get(`${SERVICES.CAMPAIGN_TRANSACTIONS}/${organizationId}/email/download`, {
      params: filters,
      paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
      responseType: 'blob'
    })

const getLogsCountries = (organizationId) => axiosInstance.get(`${SERVICES.CAMPAIGN_TRANSACTIONS}/${organizationId}/sms/countrycodes`)

export default {
  getTransactions,
  getTransactionExport,
  getLogsCountries,
  getSMSTransactionsExport,
  getEmailTransactionsExport
}
